<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tlt.log.list") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm"><span>{{$t('tlt.administration')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm/log"><span>{{$t('tlt.log')}}</span></router-link></li>
                </ul>
            </div>            
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">{{ $t("lbl.basic.startTime") }} :</label>
                                    <mmf-datetimepicker v-model="startTimeFilter"></mmf-datetimepicker>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">{{ $t("lbl.basic.endTime") }} :</label>
                                    <mmf-datetimepicker v-model="endTimeFilter"></mmf-datetimepicker>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.log.user") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="nameFilter"/>                            
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.log.description") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="descriptionFilter"/>                            
                                </div>
                                                            
                                <div class="col-lg-12 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" 
                                         v-on:click="MMFClearFilter('log')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('log')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="log" class="content">
                <div class="card my-1">
                    <div id="collapseTwo"
                         class="collapse show"
                         aria-labelledby="headingTwo"
                         data-parent="#accordionResult">

                        <div class="card-body">
                            <mmf-table entity="log" inline-actions-disabled checkbox-column-disabled>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/adm/Log";
import MmfTable from "@/components/MmfTableNoBtn";
import MmfDatetimepicker from "@/components/MmfDatetimepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'log/getField',
    mutationType: 'log/updateField',
  });

export default {
  data () {
    return {
      currentPage: 1,
      displayedValue: "",
      perPage: 15
    }
  },
  components: { MmfTable, MmfDatetimepicker},
  name: "logList",
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        //define the state of rows and fields of grid
        ...mapState({
            rows: state => state.log.rows,
            checkedItems: state => state.log.checkedItems,
            showNoResultAlert: state => state.base.showNoResultAlert,
            tableColumns: gridFields
        })
  },
  methods: {
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"])
  }
};
</script>
